import { render, staticRenderFns } from "./heaterCalculatorCta.vue?vue&type=template&id=3ff6651d"
import script from "./heaterCalculatorCta.vue?vue&type=script&lang=js"
export * from "./heaterCalculatorCta.vue?vue&type=script&lang=js"
import style0 from "./heaterCalculatorCta.vue?vue&type=style&index=0&id=3ff6651d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default})
